
module.exports = {
  // TODO: change your profile information here
  name: "Vishnu Kumar Reddy",
  greeting: "Hey 👋",
  greetingDescription: "I'm Vishnu Kumar Reddy and I'm a Computer Geek!",
  githubUrl: "https://github.com/vishnukumar650",
  linkedinUrl: "https://linkedin.com/in/vishnukumar650",
  cvLink: "https://drive.google.com/file/d/1Zg7ntPF0Eqd56M-SL3q6KsWMlJuL4Y75/view?usp=sharing",
};
